var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndustry = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 3C8.25 2.17157 7.57843 1.5 6.75 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V21C1.5 21.8284 2.17157 22.5 3 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V6.78348C22.5 6.15937 21.7822 5.8083 21.2895 6.19146L15.75 10.5V7.32464C15.75 6.74167 15.114 6.38159 14.6141 6.68152L8.25 10.5V3ZM6.75 3H3V21H21V8.25L15.4605 12.5585C14.9678 12.9417 14.25 12.5906 14.25 11.9665V8.7L7.88587 12.5185C7.38598 12.8184 6.75 12.4583 6.75 11.8754V3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndustry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/industry.78aa694fc1d9315f6b46754bf5c1bafe.svg";